(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.ZUGButtonNativeRate = api;
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';

  var EXPECTED_RATES = [1, 4, 64, 100];
  var ALLOWED_PUBLIC_KEYS = [
    'Shape',
    'Finished Size',
    'Pieces',
    'Material',
    'Finish',
    'Turnaround',
    'Artwork Status'
  ];
  var FORBIDDEN_KEYS = [
    'Product',
    'Original Artwork',
    'Proof Preview',
    'Artwork Note',
    'Job ID',
    'calc_line_uid',
    '_pricing_engine',
    '_line_type',
    '_upload_id',
    '_artwork_mode',
    '_artwork_approved',
    '_artwork_original_url',
    '_dcf_preview_url',
    '_calc_data',
    '_job_id',
    '_carrier_strategy',
    '_carrier_contract',
    '_carrier_profile',
    '_carrier_source_product_id',
    '_bundle_quantity_locked',
    '_bundle_display_quantity'
  ];

  function positiveInteger(value) {
    var number = Number(value);
    return Number.isInteger(number) && number > 0 ? number : 0;
  }

  function normalizedText(value) {
    return String(value || '').trim().toLowerCase();
  }

  function prepare(raw) {
    if (!raw || raw.schemaVersion !== 1 ||
        raw.status !== 'production_button_native_rates' ||
        raw.family !== 'button' ||
        raw.contractVersion !== 'button_native_rates_v1' ||
        !raw.contract || raw.contract.exactRepresentationsOnly !== true ||
        raw.contract.hiddenDollarCentFallback !== false ||
        positiveInteger(raw.contract.maximumEncodedQuantity) !== 200000 ||
        positiveInteger(raw.contract.rateCount) !== EXPECTED_RATES.length ||
        !raw.sourceProduct || positiveInteger(raw.sourceProduct.productId) !== 1830201524266 ||
        raw.sourceProduct.handle !== '1-inch-custom-buttons' ||
        raw.sourceProduct.recipeId !== 'button' ||
        !Array.isArray(raw.sourceProduct.activationTags) ||
        raw.sourceProduct.activationTags.length !== 1 ||
        raw.sourceProduct.activationTags[0] !== 'ZUG_MAT:button_1' ||
        !raw.product || positiveInteger(raw.product.productId) !== 8293993578559 ||
        raw.product.handle !== 'button-native-rate' ||
        !Array.isArray(raw.product.rates)) {
      throw new Error('Button native-rate catalog contract is invalid.');
    }

    var seenRates = {};
    var seenVariants = {};
    var seenSkus = {};
    var rates = raw.product.rates.map(function (entry) {
      var rateCents = positiveInteger(entry.rateCents);
      var variantId = positiveInteger(entry.variantId);
      var sku = String(entry.sku || '').trim();
      if (!rateCents || !variantId || !sku ||
          EXPECTED_RATES.indexOf(rateCents) === -1 ||
          seenRates[rateCents] || seenVariants[variantId] || seenSkus[sku] ||
          !/^ZUG-BUTTON-NATIVE-RATE-(001|004|064|100)$/.test(sku)) {
        throw new Error('Button native-rate mapping is invalid or duplicated.');
      }
      seenRates[rateCents] = true;
      seenVariants[variantId] = true;
      seenSkus[sku] = true;
      return {
        rateCents: rateCents,
        variantId: variantId,
        sku: sku,
        title: String(entry.title || '')
      };
    });

    if (EXPECTED_RATES.some(function (rate) { return !seenRates[rate]; })) {
      throw new Error('Button native-rate denominations are incomplete.');
    }
    rates.sort(function (left, right) { return right.rateCents - left.rateCents; });

    return {
      version: raw.contractVersion,
      maximumEncodedQuantity: positiveInteger(raw.contract.maximumEncodedQuantity),
      sourceProduct: {
        productId: positiveInteger(raw.sourceProduct.productId),
        handle: raw.sourceProduct.handle,
        recipeId: raw.sourceProduct.recipeId,
        activationTags: raw.sourceProduct.activationTags.slice()
      },
      product: {
        productId: positiveInteger(raw.product.productId),
        title: String(raw.product.title || ''),
        handle: raw.product.handle,
        rates: rates
      }
    };
  }

  function classify(input, contract) {
    input = input || {};
    var productId = positiveInteger(input.productId);
    var handle = String(input.handle || '');
    var recipeId = String(input.recipeId || '');
    var eligible = productId === 1830201524266 ||
      handle === '1-inch-custom-buttons' || recipeId === 'button';
    if (!eligible) return { eligible: false, active: false, reason: 'different_product' };
    if (!contract || !contract.sourceProduct) {
      return { eligible: true, active: false, reason: 'catalog_unavailable' };
    }
    if (productId !== contract.sourceProduct.productId) {
      return { eligible: true, active: false, reason: 'wrong_product_id' };
    }
    if (handle !== contract.sourceProduct.handle) {
      return { eligible: true, active: false, reason: 'wrong_handle' };
    }
    if (recipeId !== contract.sourceProduct.recipeId) {
      return { eligible: true, active: false, reason: 'wrong_recipe' };
    }
    var tags = (input.tags || []).map(String);
    var hasRequiredTag = contract.sourceProduct.activationTags.some(function (tag) {
      return tags.indexOf(tag) !== -1;
    });
    if (!hasRequiredTag) {
      return { eligible: true, active: false, reason: 'missing_activation_tag' };
    }
    return { eligible: true, active: true, reason: 'button_native_rate' };
  }

  function resolve(totalCents, contract) {
    var target = positiveInteger(totalCents);
    if (!target || !contract || !contract.product ||
        !Array.isArray(contract.product.rates) ||
        positiveInteger(contract.maximumEncodedQuantity) !== 200000) {
      throw new Error('Button native-rate pricing input is invalid.');
    }
    var selected = contract.product.rates.find(function (rate) {
      return target % rate.rateCents === 0 &&
        target / rate.rateCents <= contract.maximumEncodedQuantity;
    });
    if (!selected) {
      throw new Error('Button total cannot be represented by the approved native rates.');
    }
    var encodedQuantity = target / selected.rateCents;
    return {
      contractVersion: contract.version,
      targetTotalCents: target,
      rateCents: selected.rateCents,
      variantId: selected.variantId,
      sku: selected.sku,
      encodedQuantity: encodedQuantity,
      nativeTotalCents: selected.rateCents * encodedQuantity
    };
  }

  function firstValue(source, keys) {
    for (var index = 0; index < keys.length; index += 1) {
      var value = source[keys[index]];
      if (value !== undefined && value !== null && String(value).trim()) return String(value).trim();
    }
    return '';
  }

  function cleanProperties(input, contract, uid, pieces, source) {
    var raw = Object.assign({}, input || {});
    var properties = {};
    ALLOWED_PUBLIC_KEYS.forEach(function (key) {
      var value = String(raw[key] || '').trim();
      if (value) properties[key] = value;
    });
    if (normalizedText(properties.Material) === 'button_1' ||
        normalizedText(properties.Material) === 'button') {
      properties.Material = 'Button';
    }
    properties.Pieces = String(positiveInteger(pieces));
    properties._calc_line_uid = String(uid || '').trim();
    properties._is_button_native = 'true';

    var originalArtwork = firstValue(raw, [
      '_original_artwork', '_artwork_original_url', 'Original Artwork'
    ]);
    var proofPreview = firstValue(raw, [
      '_proof_preview', '_dcf_preview_url', 'Proof Preview'
    ]);
    if (originalArtwork) properties._original_artwork = originalArtwork;
    if (proofPreview) properties._proof_preview = proofPreview;

    source = source || {};
    var sourceTitle = String(source.title || '').trim();
    var sourceUrl = String(source.url || '').trim();
    var sourceImage = String(source.image || '').trim();
    if (sourceTitle) properties._product_title = sourceTitle;
    if (sourceUrl) properties._storefront_product_url = sourceUrl;
    if (sourceImage) properties._storefront_product_image = sourceImage;
    if (sourceTitle && normalizedText(sourceTitle) !== normalizedText(contract.product.title)) {
      properties.Product = sourceTitle;
    }

    if (!properties._calc_line_uid || properties.Pieces === '0') {
      throw new Error('Button line identity is invalid.');
    }
    return properties;
  }

  function buildLine(input) {
    input = input || {};
    var resolution = resolve(input.totalCents, input.contract);
    return {
      item: {
        id: resolution.variantId,
        quantity: resolution.encodedQuantity,
        properties: cleanProperties(
          input.properties,
          input.contract,
          input.uid,
          input.pieces,
          input.source
        )
      },
      resolution: resolution
    };
  }

  function verifyCartLine(item, resolution, uid, pieces) {
    var properties = item && item.properties ? item.properties : {};
    var publicKeys = Object.keys(properties).filter(function (key) {
      return key.charAt(0) !== '_';
    });
    return Boolean(item && resolution &&
      Number(item.variant_id || item.id) === Number(resolution.variantId) &&
      Number(item.quantity) === Number(resolution.encodedQuantity) &&
      Number(item.final_line_price) === Number(resolution.targetTotalCents) &&
      properties._calc_line_uid === uid &&
      properties._is_button_native === 'true' &&
      String(properties.Pieces) === String(pieces) &&
      publicKeys.every(function (key) { return ALLOWED_PUBLIC_KEYS.indexOf(key) !== -1; }) &&
      FORBIDDEN_KEYS.every(function (key) {
        return !Object.prototype.hasOwnProperty.call(properties, key);
      }));
  }

  function verifyCart(cart, resolution, uid, pieces) {
    var lines = (cart && cart.items || []).filter(function (item) {
      return item.properties && item.properties._calc_line_uid === uid;
    });
    return lines.length === 1 && verifyCartLine(lines[0], resolution, uid, pieces);
  }

  return {
    expectedRates: EXPECTED_RATES.slice(),
    allowedPublicKeys: ALLOWED_PUBLIC_KEYS.slice(),
    forbiddenKeys: FORBIDDEN_KEYS.slice(),
    prepare: prepare,
    classify: classify,
    resolve: resolve,
    cleanProperties: cleanProperties,
    buildLine: buildLine,
    verifyCartLine: verifyCartLine,
    verifyCart: verifyCart
  };
});
